export default "__VITE_ASSET__C99GgWD0__"